export default {
  propertySortList: [
    {
      propertyName: "firstName",
      direction: "asc",
    },
  ],
};
